import React from "react";

const UpgradePrompt = ({ onShowSubscriptionMenu }) => {
  return (
    <div className="upgrade-prompt-timer">
      <div className="timer-upgrade-box" onClick={onShowSubscriptionMenu}>
        <div className="upgrade-paragraph">
          📊 Subscribe to unlock task timing and tracking!
        </div>
        <button className="upgrade-button">Subscribe</button>
      </div>
    </div>
  );
};

export default UpgradePrompt;
